<div class="teb" role="region" aria-label="TST Expo" *ngIf="shown()">
  <div class="container teb-inner">
    <span class="teb-icon" aria-hidden="true">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.8" />
        <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        <path d="m9.5 15 1.8 1.8 3.4-3.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </span>

    <p class="teb-text">
      <strong class="teb-title">Register for the TST Expo</strong>
      <span class="teb-meta">Nov 18&ndash;19, 2026 &middot; Bloomfield, NJ</span>
    </p>

    <a class="teb-cta" [href]="url" target="_blank" rel="noopener">
      <span>Register<span class="teb-cta-now"> now</span></span>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </a>

    <button type="button" class="teb-close" (click)="dismiss()" aria-label="Dismiss TST Expo banner">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" />
      </svg>
    </button>
  </div>
</div>
